import { Module } from '@nestjs/common';
import { ListaPreciosModule } from '../lista-precios/lista-precios.module';
import { winstonConfig } from '../common/logger/winston.config';
import { BulkFilasService } from './bulk-filas.service';
import { ProductosController } from './productos.controller';
import { ProductosService } from './productos.service';

@Module({
  // ListaPreciosModule: para resolver el precio de venta EFECTIVO (el de la lista
  // de precios, que puede venir de una regla) en el listado de productos —
  // `productos.precio` es solo el valor de referencia manual y queda en 0 cuando
  // el precio real vive en una lista.
  imports: [ListaPreciosModule],
  controllers: [ProductosController],
  providers: [ProductosService, BulkFilasService],
})
export class ProductosModule {}
